export interface City {
  id: string;
  name: string;
  description: string;
  image: string;
  imageUrl: string; // For background image
  attractions: string[];
  rating: number;
  bestTimeToVisit: string;
  famousFor: string[];
}

export const cities: City[] = [
  {
    id: 'jaipur',
    name: 'Jaipur',
    description: 'Known as the Pink City, Jaipur is famous for its stunning architecture, rich culture, and vibrant bazaars.',
    image: 'https://www.tripsavvy.com/thmb/Afl1v6bgmGid9kPfseymDiAYWa0=/3595x2397/filters:no_upscale():max_bytes(150000):strip_icc()/GettyImages-518387310-04a30994bfb1461bb8000f1864ca1fc5.jpg',
    imageUrl: 'https://www.tripsavvy.com/thmb/Afl1v6bgmGid9kPfseymDiAYWa0=/3595x2397/filters:no_upscale():max_bytes(150000):strip_icc()/GettyImages-518387310-04a30994bfb1461bb8000f1864ca1fc5.jpg',
    attractions: ['Hawa Mahal', 'City Palace', 'Amber Fort', 'Jantar Mantar', 'Albert Hall Museum'],
    rating: 4.8,
    bestTimeToVisit: 'October to March',
    famousFor: ['Pink Architecture', 'Royal Heritage', 'Traditional Crafts', 'Rajasthani Cuisine']
  },
  {
    id: 'udaipur',
    name: 'Udaipur',
    description: 'The City of Lakes, Udaipur is renowned for its lavish palaces, beautiful lakes, and romantic atmosphere.',
    image: 'https://images.unsplash.com/photo-1599661046289-e31897846e41?q=80&w=1000&auto=format&fit=crop',
    imageUrl: 'https://images.unsplash.com/photo-1599661046289-e31897846e41?q=80&w=1000&auto=format&fit=crop',
    attractions: ['Lake Palace', 'City Palace', 'Lake Pichola', 'Jagdish Temple', 'Fateh Sagar Lake'],
    rating: 4.7,
    bestTimeToVisit: 'September to March',
    famousFor: ['Lakes', 'Royal Palaces', 'Rajasthani Art', 'Romantic Atmosphere']
  },
  {
    id: 'goa',
    name: 'Goa',
    description: 'A paradise for beach lovers, Goa offers pristine beaches, vibrant nightlife, and Portuguese heritage.',
    image: 'http://blog.bedandchai.com/wp-content/uploads/2015/12/World___India_Relax_on_the_beach_in_Arambol_068131_.jpg',
    imageUrl: 'http://blog.bedandchai.com/wp-content/uploads/2015/12/World___India_Relax_on_the_beach_in_Arambol_068131_.jpg',
    attractions: ['Calangute Beach', 'Basilica of Bom Jesus', 'Fort Aguada', 'Dudhsagar Falls', 'Anjuna Flea Market'],
    rating: 4.9,
    bestTimeToVisit: 'November to February',
    famousFor: ['Beaches', 'Nightlife', 'Portuguese Architecture', 'Seafood']
  },
  {
    id: 'mahabaleshwar',
    name: 'Mahabaleshwar',
    description: 'A serene hill station known for its strawberry farms, scenic viewpoints, and pleasant weather.',
    image: 'https://1.bp.blogspot.com/-XHzY-JbsKxo/Xd1C9NZfU3I/AAAAAAAADnI/TjJxmflZmoQ2wzlfy7kAyr5wzXo90eX3ACNcBGAsYHQ/s1600/needle%2Bpoint.jpg',
    imageUrl: 'https://1.bp.blogspot.com/-XHzY-JbsKxo/Xd1C9NZfU3I/AAAAAAAADnI/TjJxmflZmoQ2wzlfy7kAyr5wzXo90eX3ACNcBGAsYHQ/s1600/needle%2Bpoint.jpg',
    attractions: ['Venna Lake', 'Pratapgad Fort', 'Arthur\'s Seat', 'Mapro Garden', 'Lingmala Waterfall'],
    rating: 4.6,
    bestTimeToVisit: 'December to February',
    famousFor: ['Strawberries', 'Viewpoints', 'Pleasant Weather', 'Hiking Trails']
  },
  {
    id: 'agra',
    name: 'Agra',
    description: 'Home to the iconic Taj Mahal, Agra showcases the finest Mughal architecture and history.',
    image: 'https://images.ixigo.com/image/upload/t_thumb,f_auto/taj-mahal-images-photos-56f8c663bad3eb6e7214124a.jpg',
    imageUrl: 'https://images.ixigo.com/image/upload/t_thumb,f_auto/taj-mahal-images-photos-56f8c663bad3eb6e7214124a.jpg',
    attractions: ['Taj Mahal', 'Agra Fort', 'Fatehpur Sikri', 'Akbar\'s Tomb', 'Mehtab Bagh'],
    rating: 4.8,
    bestTimeToVisit: 'October to March',
    famousFor: ['Taj Mahal', 'Mughal Architecture', 'Historical Monuments', 'Petha Sweets']
  },
  {
    id: 'mumbai',
    name: 'Mumbai',
    description: 'The city that never sleeps, Mumbai offers a perfect blend of culture, entertainment, and food.',
    image: 'https://wallpapercave.com/wp/wp3768669.jpg',
    imageUrl: 'https://wallpapercave.com/wp/wp3768669.jpg',
    attractions: ['Gateway of India', 'Marine Drive', 'Colaba Causeway', 'Elephanta Caves', 'Juhu Beach'],
    rating: 4.7,
    bestTimeToVisit: 'October to February',
    famousFor: ['Bollywood', 'Street Food', 'Colonial Architecture', 'Shopping']
  },
  {
    id: 'delhi',
    name: 'Delhi',
    description: 'The capital city of India, Delhi is a blend of history, culture, and modern development.',
    image: 'https://static.toiimg.com/photo/msid-49450573,width-96,height-65.cms',
    imageUrl: 'https://static.toiimg.com/photo/msid-49450573,width-96,height-65.cms',
    attractions: ['Red Fort', 'Qutub Minar', 'India Gate', 'Humayun\'s Tomb', 'Lotus Temple'],
    rating: 4.6,
    bestTimeToVisit: 'October to March',
    famousFor: ['Historical Monuments', 'Street Food', 'Shopping Markets', 'Cultural Heritage']
  },
  {
    id: 'chennai',
    name: 'Chennai',
    description: 'The cultural capital of South India, Chennai offers beautiful beaches, temples, and authentic Tamil cuisine.',
    image: 'https://image3.mouthshut.com/images/imagesp/925004348s.jpg',
    imageUrl: 'https://image3.mouthshut.com/images/imagesp/925004348s.jpg',
    attractions: ['Marina Beach', 'Kapaleeshwarar Temple', 'Fort St. George', 'San Thome Basilica', 'MGR Film City'],
    rating: 4.5,
    bestTimeToVisit: 'November to February',
    famousFor: ['South Indian Cuisine', 'Temples', 'Beaches', 'Classical Music and Dance']
  },
  {
    id: 'hyderabad',
    name: 'Hyderabad',
    description: 'The City of Nizams, famous for its rich history, delectable cuisine, and IT hub.',
    image: 'https://dynamic-media-cdn.tripadvisor.com/media/photo-o/0f/98/f7/df/charminar.jpg?w=1800&h=1000&s=1',
    imageUrl: 'https://dynamic-media-cdn.tripadvisor.com/media/photo-o/0f/98/f7/df/charminar.jpg?w=1800&h=1000&s=1',
    attractions: ['Charminar', 'Golconda Fort', 'Ramoji Film City', 'Hussain Sagar', 'Birla Mandir'],
    rating: 4.7,
    bestTimeToVisit: 'October to February',
    famousFor: ['Biryani', 'Historical Monuments', 'Pearls', 'Tech Parks']
  },
  {
    id: 'pune',
    name: 'Pune',
    description: 'The Oxford of the East, Pune is known for its educational institutions, historical sites, and pleasant weather.',
    image: 'https://resize.indiatvnews.com/en/resize/newbucket/1200_-/2021/07/pune-1625115438.jpg',
    imageUrl: 'https://resize.indiatvnews.com/en/resize/newbucket/1200_-/2021/07/pune-1625115438.jpg',
    attractions: ['Shaniwar Wada', 'Aga Khan Palace', 'Dagdusheth Ganpati', 'Sinhagad Fort', 'Osho Ashram'],
    rating: 4.6,
    bestTimeToVisit: 'July to February',
    famousFor: ['Education Hub', 'Historical Forts', 'Gardens', 'IT Industry']
  },
  {
    id: 'varanasi',
    name: 'Varanasi',
    description: 'The spiritual capital of India, Varanasi is one of the oldest living cities in the world.',
    image: 'https://www.tripsavvy.com/thmb/QeX3TKxhqJov-DELtQoTlxD1yLc=/2121x1414/filters:fill(auto,1)/GettyImages-174121423-5af5b106a18d9e003cc4a1f0.jpg',
    imageUrl: 'https://www.tripsavvy.com/thmb/QeX3TKxhqJov-DELtQoTlxD1yLc=/2121x1414/filters:fill(auto,1)/GettyImages-174121423-5af5b106a18d9e003cc4a1f0.jpg',
    attractions: ['Dashashwamedh Ghat', 'Kashi Vishwanath Temple', 'Sarnath', 'Assi Ghat', 'Ramnagar Fort'],
    rating: 4.8,
    bestTimeToVisit: 'October to March',
    famousFor: ['Spiritual Atmosphere', 'Ghats', 'Classical Music', 'Silk Sarees']
  },
  {
    id: 'ooty',
    name: 'Ooty',
    description: 'Known as the Queen of Hill Stations, Ooty is famous for its scenic beauty, tea gardens, and pleasant climate.',
    image: 'https://upload.wikimedia.org/wikipedia/commons/2/29/Botanical_Garden_in_Ooty%2C_Tamil_Nadu.JPG',
    imageUrl: 'https://upload.wikimedia.org/wikipedia/commons/2/29/Botanical_Garden_in_Ooty%2C_Tamil_Nadu.JPG',
    attractions: ['Botanical Gardens', 'Ooty Lake', 'Doddabetta Peak', 'Rose Garden', 'Nilgiri Mountain Railway'],
    rating: 4.7,
    bestTimeToVisit: 'October to June',
    famousFor: ['Tea Gardens', 'Botanical Gardens', 'Pleasant Weather', 'Mountain Railways']
  },
  {
    id: 'mysore',
    name: 'Mysore',
    description: 'The City of Palaces, Mysore is known for its rich heritage, magnificent palaces, and cultural attractions.',
    image: 'https://www.moxon.net/images/india/1600/mysore1.jpg',
    imageUrl: 'https://www.moxon.net/images/india/1600/mysore1.jpg',
    attractions: ['Mysore Palace', 'Chamundi Hills', 'Brindavan Gardens', 'St. Philomena\'s Church', 'Mysore Zoo'],
    rating: 4.8,
    bestTimeToVisit: 'October to March',
    famousFor: ['Mysore Palace', 'Silk Sarees', 'Sandalwood', 'Mysore Pak']
  },
  {
    id: 'amritsar',
    name: 'Amritsar',
    description: 'The spiritual and cultural center of the Sikh religion, famous for the Golden Temple and rich Punjabi culture.',
    image: 'https://media.cntraveller.in/wp-content/uploads/2019/11/GettyImages-121109155.jpg',
    imageUrl: 'https://media.cntraveller.in/wp-content/uploads/2019/11/GettyImages-121109155.jpg',
    attractions: ['Golden Temple', 'Jallianwala Bagh', 'Wagah Border', 'Gobindgarh Fort', 'Durgiana Temple'],
    rating: 4.9,
    bestTimeToVisit: 'November to March',
    famousFor: ['Golden Temple', 'Punjabi Cuisine', 'Historical Sites', 'Cultural Heritage']
  },
  {
    id: 'manali',
    name: 'Manali',
    description: 'A picturesque hill station known for its snow-capped mountains, adventure sports, and natural beauty.',
    image: 'https://imgcld.yatra.com/ytimages/image/upload/v1462942334/Manali_History.jpg',
    imageUrl: 'https://imgcld.yatra.com/ytimages/image/upload/v1462942334/Manali_History.jpg',
    attractions: ['Rohtang Pass', 'Hadimba Temple', 'Solang Valley', 'Mall Road', 'Vashisht Hot Springs'],
    rating: 4.8,
    bestTimeToVisit: 'October to June',
    famousFor: ['Adventure Sports', 'Snow Activities', 'Honeymoon Destination', 'Natural Beauty']
  },
  {
    id: 'shimla',
    name: 'Shimla',
    description: 'The former summer capital of British India, Shimla is a charming hill station with colonial architecture.',
    image: 'https://indiasomeday.com/wp-content/uploads/2020/08/naman-pandey-y3nWJ-QznP4-unsplash.jpg',
    imageUrl: 'https://indiasomeday.com/wp-content/uploads/2020/08/naman-pandey-y3nWJ-QznP4-unsplash.jpg',
    attractions: ['The Ridge', 'Mall Road', 'Christ Church', 'Jakhu Temple', 'Kufri'],
    rating: 4.7,
    bestTimeToVisit: 'March to June',
    famousFor: ['Colonial Architecture', 'Toy Train', 'Shopping', 'Winter Sports']
  },
  {
    id: 'rishikesh',
    name: 'Rishikesh',
    description: 'The Yoga Capital of the World, Rishikesh is a spiritual hub known for its ashrams and adventure activities.',
    image: 'https://www.ragaontheganges.com/assets/img/blog/guide-to-rishikesh.jpg',
    imageUrl: 'https://www.ragaontheganges.com/assets/img/blog/guide-to-rishikesh.jpg',
    attractions: ['Laxman Jhula', 'Ram Jhula', 'Beatles Ashram', 'Triveni Ghat', 'Neelkanth Mahadev Temple'],
    rating: 4.8,
    bestTimeToVisit: 'September to April',
    famousFor: ['Yoga', 'River Rafting', 'Spiritual Centers', 'Adventure Sports']
  },
  {
    id: 'haridwar',
    name: 'Haridwar',
    description: 'One of the holiest cities in India, where the River Ganges descends from the Himalayas.',
    image: 'http://www.holidaytravelzone.com/bootstrap/images/package/uploads/original/Haridwar_Tour_Package.jpg',
    imageUrl: 'http://www.holidaytravelzone.com/bootstrap/images/package/uploads/original/Haridwar_Tour_Package.jpg',
    attractions: ['Har Ki Pauri', 'Mansa Devi Temple', 'Chandi Devi Temple', 'Maya Devi Temple', 'Ganga Aarti'],
    rating: 4.7,
    bestTimeToVisit: 'October to March',
    famousFor: ['Ganga Aarti', 'Spiritual Atmosphere', 'Ancient Temples', 'Religious Ceremonies']
  },
  {
    id: 'ahmedabad',
    name: 'Ahmedabad',
    description: 'The first UNESCO World Heritage City in India, known for its rich cultural heritage and historical monuments.',
    image: 'https://assets-news.housing.com/news/wp-content/uploads/2022/07/22131515/Ahmedabad-thumbnail.jpg',
    imageUrl: 'https://assets-news.housing.com/news/wp-content/uploads/2022/07/22131515/Ahmedabad-thumbnail.jpg',
    attractions: ['Sabarmati Ashram', 'Sidi Saiyyed Mosque', 'Adalaj Stepwell', 'Kankaria Lake', 'Auto World Vintage Car Museum'],
    rating: 4.6,
    bestTimeToVisit: 'October to March',
    famousFor: ['Heritage Architecture', 'Street Food', 'Textile Industry', 'Cultural Festivals']
  },
  {
    id: 'bhopal',
    name: 'Bhopal',
    description: 'The City of Lakes, Bhopal combines Islamic architecture with modern urban planning.',
    image: 'https://cdn.theculturetrip.com/wp-content/uploads/2016/04/tajul-masajid.jpeg',
    imageUrl: 'https://cdn.theculturetrip.com/wp-content/uploads/2016/04/tajul-masajid.jpeg',
    attractions: ['Taj-ul-Masajid', 'Upper Lake', 'Van Vihar National Park', 'Bhimbetka Caves', 'State Museum'],
    rating: 4.5,
    bestTimeToVisit: 'October to March',
    famousFor: ['Lakes', 'Historical Monuments', 'Museums', 'Rock Shelters']
  },
  {
    id: 'kochi',
    name: 'Kochi',
    description: 'A major port city known for its unique blend of Dutch, Portuguese, and British heritage.',
    image: 'http://www.theholidayindia.com/blog/wp-content/uploads/2015/09/Kochi-18.jpg',
    imageUrl: 'http://www.theholidayindia.com/blog/wp-content/uploads/2015/09/Kochi-18.jpg',
    attractions: ['Chinese Fishing Nets', 'Fort Kochi Beach', 'Mattancherry Palace', 'St. Francis Church', 'Marine Drive'],
    rating: 4.7,
    bestTimeToVisit: 'October to March',
    famousFor: ['Chinese Fishing Nets', 'Colonial Architecture', 'Seafood', 'Art Galleries']
  }
];